import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6gzjmj6pk: FaireProductEntity = {
  token: "p_m6gzjmj6pk",
  type: "product",
  name: "In Full Bloom Candle",
  brandToken: "b_xjywu3etzs",
  brandName: "Element Brooklyn",
  imageUrl:
    "https://cdn.faire.com/fastly/e15b042aef854f3e03bfeeea7a25f8f61414c715131c55839458bf793259f36f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8324c7a1855b59f140f5c61bf0b027480d86b86c49015dcd315a8b942bec7cb5.jpeg",
    "https://cdn.faire.com/fastly/148dc68dd7e8df353f68ea0e7297153e4bdbbb492aa51438a963bb9a55733ff3.jpeg",
    "https://cdn.faire.com/fastly/60a7a6d169eb28fd465a65374adc9e5f00370ad71ab259e027b9964c29bedf8a.jpeg",
    "https://cdn.faire.com/fastly/f76e375fd22f45daa1bffadf2568a3ed8fefa3dbb2e40294ead50c25987c89f2.jpeg",
    "https://cdn.faire.com/fastly/46d601c70fe89010f108070ad46e44e0f5e1fc8dbf0d39db31393f23ef8893af.jpeg",
  ],
  priceDollars: 9.9,
  description:
    "A classical garden at the height of spring. The faintest breeze. Leaf, fruit and flower in just the right proportions. Instant sophistication.\n\n🏆 HGTV: Best Sustainable Candle\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:59.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
